import log from '../utils/log'

export class ValetCustomerTablet {
  init () {
    if ($('#selectAction').length) {
      this.initTabletEditAction()
    } else if ($('#updatePage').length) {
      this.initTabletUpdateAction()
    }
    if ($('#areYouStillThere').length) {
      this.initAreYouStillThere()
    }

    this.initCheckboxes()

    window.scanTag = function (tag) {
      if ($('#valet-scan-tag-form').length) {
        $('#valet-scan-tag-form #nfc_code').val(tag)
        return $('#valet-scan-tag-form').submit()
      } else {
        return log.debug("Form not present, can't scan!")
      }
    }
  }

  initTabletEditAction () {
    $('.slide-action-button').on('click', e => {
      e.preventDefault()
      let $target = $(e.target)
      if ($target.parents('.slide-action-button').length) {
        $target = $target.parents('.slide-action-button')
      }
      if ($target.attr('data-action') === 'customer_dropped_off') {
        $('#selectAction').collapse('hide')
        $('#selectBikeToPark').collapse('show')
      } else if ($target.attr('data-action') === 'customer_retrieve_request') {
        $('#selectAction').collapse('hide')
        $('#selectBikeToRetrieve').collapse('show')
      } else {
        log.debug($target.attr('data-action'))
      }
      $('#backButtonWrapper').collapse('show')
    })
    $('#backToSelectAction').on('click', e => {
      e.preventDefault()
      $('.shown-on-action-selected').collapse('hide')
      $('#selectAction').collapse('show')
    })
  }

  initTabletUpdateAction () {
    window.timeRemaining = parseInt(
      $('#timeTillReturn').attr('data-seconds'),
      10
    )
    window.valetCustomerTablet.updateCountdownToReturn()
  }

  updateCountdownToReturn () {
    if (window.timeRemaining > 1) {
      window.timeRemaining -= 1
      $('#timeTillReturn').text(window.timeRemaining)
      window.setTimeout(
        window.valetCustomerTablet.updateCountdownToReturn,
        1000
      )
    } else if ($('#timeTillReturn').length) {
      // ^ Check to make sure the selector is on the page, or it will redirect to failure
      window.location = $('#timeTillReturn').attr('data-target')
    }
  }

  initAreYouStillThere () {
    const delay =
      parseInt($('#areYouStillThere').attr('data-timeout'), 10) * 1000
    window.setTimeout(this.expandAreYouStillThere, delay)
  }

  expandAreYouStillThere () {
    // In case this callback happens after the page has changed
    if (!$('#areYouStillThere').length) {
      return
    }
    $('#areYouStillThere').collapse('show')
    $('.cancel-button-wrapper').slideUp()
  }

  initCheckboxes () {
    $('.form-check-label').on('change', 'input:checkbox', function () {
      const checkboxes = $('input[type=checkbox]')
      const submitButton = $('input[type=submit]')

      const didntCheckAllBoxes = checkboxes.not(':checked').length > 0
      submitButton.prop('disabled', didntCheckAllBoxes)
    })
  }
}
